import {
  Directive,
  ElementRef,
  EventEmitter,
  inject,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[clickOutside]',
  standalone: true,
})
export class ClickOutsideDirective implements OnInit, OnDestroy {
  private elementRef = inject(ElementRef);
  private renderer = inject(Renderer2);
  private platformId = inject(PLATFORM_ID);

  private removeClickListener?: () => void;
  @Output() clickOutside = new EventEmitter<Event>();

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.removeClickListener = this.renderer.listen(
        'document',
        'click',
        (event: Event) => {
          if (!this.elementRef.nativeElement.contains(event.target)) {
            this.clickOutside.emit(event);
          }
        },
      );
    }
  }

  ngOnDestroy(): void {
    if (this.removeClickListener) {
      this.removeClickListener();
    }
  }
}
